<template >
    <div class="popup-container">
        <div class="text-justify popup-wrapper" v-if="!loading">
            <div class="popup-header">
                <span>Contact Support</span> <i class="fa fa-times close-icon" @click="closePopup"></i>
            </div>
            <div class="popup-body" v-if="msgSent">
                <div class="secondary-heading" style="margin-left:0px;max-width: 600px;">
                    We have recieved your query and will get in touch with you shortly.
                </div>
            </div>
            <div class="popup-body" v-else>
                <div class="secondary-heading" style="margin-left:0;max-width: 600px;">
                    Please write to us with your query, we will get in touch with you shortly.
                </div>
                <div class="state-agent w800 mt-2" >
                    <div class="row row-reverse">
                        <div class="col-md-12">
                            <div class="sa-frm-row mb-1">
                                <div class="sa-form-control" >
                                    <input
                                    type="text"
                                    class="sa-control"
                                    v-model="agent.fullName"
                                    placeholder="Full Name"
                                    :disabled="true"
                                    @keyup="errorText = ''"
                                    >
                                </div>
                                <div v-if="errorText == 'nameRequired'" class="sa-label error-text" style="text-align:left;">Please provide name.</div>
                            </div>
                            <div class="sa-frm-row mb-1 mt-1">
                                <div class="sa-form-control">
                                    <input
                                    type="text"
                                    class="sa-control"
                                    v-model="agent.agentKey"
                                    placeholder="NRDS"
                                    :disabled="true"
                                    @keyup="errorText = ''"
                                    >
                                </div>
                                <div v-if="errorText == 'agentKeyRequired'" class="sa-label error-text" style="text-align:left;">Please provide NRDS.</div>
                            </div>

                            <div class="sa-frm-row mb-1 mt-1">
                                <div class="sa-form-control">
                                    <input
                                    type="text"
                                    class="sa-control"
                                    v-model="agent.brokerage"
                                    :disabled="true"
                                    placeholder="Office"
                                    >
                                </div>
                            </div>
                            <div class="sa-frm-row mb-1 mt-1">
                                <div class="sa-form-control">
                                    <input
                                    type="text"
                                    class="sa-control"
                                    v-model="agent.phone"
                                    placeholder="phone"
                                    @keyup="errorText = ''"
                                    :disabled="true"
                                    v-mask="'(###) ###-####'"
                                    >
                                </div>
                                <div v-if="errorText == 'wrongPhone'" class="sa-label error-text" style="text-align:left;">Please provide a valid phone</div>
                            </div>
                            <div class="sa-frm-row mb-1 mt-1">
                                <div class="sa-form-control">
                                    <input
                                    type="text"
                                    class="sa-control"
                                    v-model="agent.email"
                                    placeholder="email"
                                    :disabled="true"
                                    @keyup="errorText = ''"
                                    >
                                </div>
                                <div v-if="errorText == 'wrongEmail'" class="sa-label error-text" style="text-align:left;">Please provide a proper email</div>
                            </div>
                            <div class="sa-frm-row mb-1 mt-1">
                                <div class="sa-form-control mt-2">
                                    <textarea placeholder="Query" style="height:80px;height: 80px;line-height: 24px;" class="sa-control" name="name" max="100" rows="4" v-model="agent.message"></textarea>
                                </div>
                                <div v-if="errorText == 'msgRequired'" class="sa-label error-text" style="text-align:left;">Please provide your query.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="popup-footer">
                <!-- <button class="close-button" style = "alignItems:center" @click = "closePopup">Close</button> -->
                <button v-if="msgSent" class="ob-button" style = "alignItems:center;float:right;width:100px;" @click = "closePopup">Ok</button>
                <button v-else class="ob-button" style = "alignItems:center;float:right;width:100px;" @click = "sendSupportMail">Send</button>
            </div>
        </div>
        <div class="loader-spinner"  v-if="loading"></div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    methods:{
        closePopup(){
            this.$emit('closePopup')
        },
        goForward(){
            this.$emit('goForward')
        },
        validatePhone(phone){
            phone = phone;
            const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
            return re.test(phone);
        },
        validateEmail(email){
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        sendSupportMail(){
            // if (!this.agent.fullName) {
            //     this.errorText = 'nameRequired'
            //     return false;
            // }
            // if (!this.agent.agentKey) {
            //     this.errorText = 'agentKeyRequired'
            //     return false;
            // }
            // if (!this.validateEmail(this.agent.email)) {
            //     this.errorText = 'wrongEmail'
            //     return false;
            // }
            // if (!this.validatePhone(this.agent.phone)) {
            //     this.errorText = 'wrongPhone'
            //     return false;
            // }
            // if (!this.agent.message) {
            //     this.errorText = 'msgRequired'
            //     return false;
            // }
            let agentInfo = this.agent;
            let displayInfo = this.displayInfo
            let mailContent = `<b>A user with below information has reached out to us with a query.</b>
            ${Object.keys(agentInfo).map( (row) => {
                return `<p>${displayInfo[row]} : ${agentInfo[row] ? agentInfo[row] : '-'}<p> \n`
                }
            ).filter(function (el) {
                return el != null;
            }).join('')}`
            console.log({mailContent});

            let payload = {}
            payload['mailContent'] = mailContent;
            this.loading = true;
            this.$store.dispatch("sentMailToAdmin", payload).then((res) => {
                this.loading = false;
                this.msgSent = true;
            })
        }
    },
    data(){
        return{
            errorText : '',
            loading:false,
            msgSent:false,
            displayInfo :{
                'email': 'Email',
                'agentKey': 'NRDS',
                'fullName': 'Name',
                'phone': 'Phone',
                'brokerage': 'Brokerage',
                'message': 'Message'
            }
        }
    },
    props:["agent"],
    computed:{
        orgTitle (){
            return this.$store.state.orgTitle
        },
        orgEmail(){
            let title = this.$store.state.orgTitle
            return "support@" + title + ".com"
        },
        mailHref(){
            let title = this.$store.state.orgTitle
            return "mailto:support@" + title + ".com"
        }
    }
}
</script>

<style lang="scss" >
.terms-text{
    overflow-y: auto;
    max-height: calc(100vh - 300px);
}
</style>
